import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import parse from "html-react-parser";
import axios from "axios";
import "./index.css";

const Footer = ({ webpageData }) => {
  const location = useLocation();
  const footerData = webpageData?.footerSection || {};
  const originalFooterLinks = footerData?.links || [];
  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";
  const sponsorData = webpageData?.sponsorSection || {};
  const sponsors = sponsorData?.sponsors || [];
  const [userLocation, setUserLocation] = useState("unknown");

  // Fetch user location from MaxMind API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          process.env.REACT_APP_MAXMIND,
          {},
          {
            headers: { "Content-Type": "application/json" },
            timeout: 5000,
          }
        );

        if (
          response.data !== "IP Not Available" &&
          response.data !== "Invalid Country"
        ) {
          
          setUserLocation(JSON.stringify(response.data)); 
        } else {
          setUserLocation("User is not from US");
        }
      } catch (error) {
        console.error("Fetch Data Error: ", error);
      }
    };

    fetchData();
  }, []);

  // console.log("My location is", userLocation);

  // Lambda interaction on sponsor PDF download
  const incrementPdfCount = async () => {
    const webpageName = "https://www.ussaic.com";
    const filePath = sponsorData?.ctaBanner?.buttonUrl
      ? new URL(sponsorData.ctaBanner.buttonUrl, window.location.origin).pathname
      : "unknown";

    try {
      await fetch(process.env.REACT_APP_DOWNLOADCOUNT_LAMBDA_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          webpageName,
          userLocation,
          filePath
        })
      });
    } catch (error) {
      console.error("Error logging sponsor PDF click:", error);
    }
  };

  // Conditionally filter footer links
  const onlyShowHostedBy =
  location.pathname === "/speakerapplication" ||
  location.search.includes("nft=");

const footerLinks = onlyShowHostedBy
  ? originalFooterLinks.filter((link) => link.label === "Hosted and Maintained by")
  : originalFooterLinks;


  // Scroll to BuyTicket/Register section with offset
  const scrollToRegisterSection = (e) => {
    e.preventDefault();
    const registerSection = document.getElementById("register-section");
    if (registerSection) {
      const elementPosition = registerSection.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 65;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const handleLinkClick = (link, e) => {
    if (link.label === "Attend" || link.url === "/attend" || link.url === "#register-section") {
      scrollToRegisterSection(e);
    }
  
    // ✅ Strictly match the Sponsor link by label and URL
    if (
      link.label === "Sponsor" &&
      link.url === "https://resources.swmc.com/ussaic/USSAIC_SponsorDeck_2025.pdf"
    ) {
      incrementPdfCount();
    }
  };

  return (
    <footer className="custom-footer">
      <Container fluid>
        <Row className="align-items-center">
          <Col md={6} className="footer-left d-flex align-items-center justify-content-start">
            <div className="logo-images">
            <Image
              src={imgCDNURL + "ussaicfooter.png"}
              alt="USSAIC Logo"
              className="footer-logo-image"
              loading="lazy"
            />
            <h5 className="in-partnership-text">In Partnership with</h5>
             <Image
             src={"https://stagingresources.swmc.com/angel-ai/latest-angelai-logo.webp"}
              alt="USSAIC Logo"
              className="footer-logo-image"
              loading="lazy"
              onClick={() => window.open("https://www.angelai.com/", "_blank")}
              style={{ cursor: "pointer" }}
            />
            </div>
          </Col>
          <Col md={6} className="footer-right d-flex align-items-center justify-content-end">
            <ul className="footer-links mb-0">
              {footerLinks.map((link, index) => (
                <li key={index}>
                  {link.company ? (
                    parse(
                      `${link.label} <a href="${link.url}" target="_blank" rel="noopener noreferrer">${link.company}</a>`
                    )
                  ) : link.label === "Attend" || link.url === "/attend" || link.url === "#register-section" ? (
                    <a
                      href="#register-section"
                      onClick={(e) => handleLinkClick(link, e)}
                      style={{ cursor: "pointer" }}
                    >
                      {parse(link.label)}
                    </a>
                  ) : (
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => handleLinkClick(link, e)}
                    >
                      {parse(link.label)}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
